import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { IoIosArrowBack } from "react-icons/io";
import SelectedMatchesCard from "./selectedMatchesCard";
// import HumburgerMenu from "../../../assets/icons/humburger.svg";
import bettingService from "../../../api/services/bettingService";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { setSelectedMatchesDetail } from '../../common/components/sidebar/sidebar.actions';
import { GiHamburgerMenu } from "react-icons/gi";
import { MdSportsSoccer } from "react-icons/md";
import { GiRunningNinja } from "react-icons/gi";

const SelectedMatches = ({ setIsLoading }) => {
    const [showOptions, setShowOptions] = useState(false);
    const [selectedMatches, setSelectedMatches] = useState([]);
    // const [selectedMatchesWithDetail, setSelectedMatchesWithDetail] = useState([]);
    const [filter, setFilter] = useState("အားလုံး");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleBackClick = () => {
        handleSongClick();
        navigate('/dashboard');
    };

    const handleHamburgerClick = () => {
        handleSongClick();
        setShowOptions(!showOptions); // Toggle options visibility
    };

    const handleOptionClick = (option) => {
        setFilter(option);
        setShowOptions(false);
    }

    useEffect(() => {
        const abortController = new AbortController();
        setIsLoading(true);
        bettingService
            .bettingMatchesHistory(abortController.signal)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    if (filter === "အားလုံး") {
                        setSelectedMatches(data);
                    } else if (filter === "ဘော်ဒီ") {
                        const filteredMatches = data.filter(
                            (match) => match.gamblingTypeId === 1
                        );
                        setSelectedMatches(filteredMatches);
                    } else if (filter === "မောင်း") {
                        const filteredMatches = data.filter(
                            (match) => match.gamblingTypeId === 2
                        );
                        setSelectedMatches(filteredMatches);
                    }
                }
                setIsLoading(false);
            })
            .catch((err) => {
                if (err.name === 'AbortError') return;
                setIsLoading(false);
                console.error("API request error:", err);
            });
        return () => abortController.abort();
    }, [filter, navigate, setIsLoading]);

    const sortedMatches = useMemo(() => {
        return [...selectedMatches].sort((a, b) => {
            const dateA = new Date(a.createdDate);
            const dateB = new Date(b.createdDate);
            return dateB - dateA;
        });
    }, [selectedMatches]);
    // useEffect(() => {
    //   if (selectedMatches && selectedMatches.length > 0) {
    //     const fetchData = async () => {
    //       const detailData = await Promise.all(
    //         selectedMatches.map(async (match) => {
    //           try {
    //             const response = await bettingService.bettingHistoryDetails({
    //               gamblingId: Number(match.gamblingId),
    //               status: "Inplay",
    //             });
    //             const data = await response.json();
    //             if (data && data.length > 0) {
    //               return { ...match, ...data[0] };
    //             }
    //           } catch (err) {
    //             if (err?.response?.status === 401) {
    //               // Redirect to the login page
    //               navigate("/login");
    //             } else {
    //               console.error("API request error:", err);
    //             }
    //           }
    //         })
    //       );
    //       setSelectedMatchesWithDetail(detailData);
    //       setIsLoading(false);
    //     };

    //     fetchData();
    //   }
    // }, [selectedMatches, navigate, setIsLoading]);

    return (
        <div className="relative flex flex-col w-full h-[100dvh] overflow-hidden bg-white">
            {/* Professional Header */}
            <div className="relative z-20 border-b-2 shadow-2xl bg-white">
                <div className="flex items-center justify-between px-5 py-4">
                    <div className="flex justify-start">
                        <button
                            onClick={handleBackClick}
                            className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
                        >
                            <IoIosArrowBack size={24} />
                        </button>
                    </div>
                    <div className="flex items-center gap-3 mr-7">
                        <div className="flex items-center justify-center w-12 h-12 border-2 shadow-lg bg-gradient-to-br from-crimson via-red-primary to-crimson rounded-xl border-golden/40">
                            <GiRunningNinja size={22} className="text-white drop-shadow-lg" />
                        </div>
                        <h3 className="text-lg font-bold leading-tight text-blue-primary">{t("selectedMatches")}</h3>
                    </div>
                    <button
                        onClick={handleHamburgerClick}
                        className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
                    >
                        <GiHamburgerMenu size={22} />
                    </button>
                </div>
                {/* Luxury Border Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 shadow-lg bg-gradient-to-r from-crimson via-golden to-crimson"></div>

                {/* Enhanced Filter Menu */}
                {showOptions && (
                    <div className="absolute top-20 right-5 bg-white/95 backdrop-blur-xl rounded-2xl border-2 border-crimson/30 shadow-2xl p-2 min-w-[180px] z-[100]">
                        <div className="space-y-1">
                            <div
                                className={`cursor-pointer px-4 py-3 rounded-xl transition-all duration-200 ${filter === "အားလုံး"
                                    ? "bg-gradient-to-br from-crimson via-red-primary to-crimson text-white font-semibold shadow-lg border-2 border-golden/40"
                                    : "text-blue-primary hover:bg-crimson/5 border-2 border-transparent"
                                    }`}
                                onClick={() => handleOptionClick("အားလုံး")}
                            >
                                <div className="flex items-center">
                                    <div className={`w-2 h-2 rounded-full mr-3 ${filter === "အားလုံး" ? "bg-white" : "bg-crimson"}`}></div>
                                    {t("all")}
                                </div>
                            </div>
                            <div
                                className={`cursor-pointer px-4 py-3 rounded-xl transition-all duration-200 ${filter === "မောင်း"
                                    ? "bg-gradient-to-br from-crimson via-red-primary to-crimson text-white font-semibold shadow-lg border-2 border-golden/40"
                                    : "text-blue-primary hover:bg-crimson/5 border-2 border-transparent"
                                    }`}
                                onClick={() => handleOptionClick("မောင်း")}
                            >
                                <div className="flex items-center">
                                    <div className={`w-2 h-2 rounded-full mr-3 ${filter === "မောင်း" ? "bg-white" : "bg-crimson"}`}></div>
                                    {t("maungg")}
                                </div>
                            </div>
                            <div
                                className={`cursor-pointer px-4 py-3 rounded-xl transition-all duration-200 ${filter === "ဘော်ဒီ"
                                    ? "bg-gradient-to-br from-crimson via-red-primary to-crimson text-white font-semibold shadow-lg border-2 border-golden/40"
                                    : "text-blue-primary hover:bg-crimson/5 border-2 border-transparent"
                                    }`}
                                onClick={() => handleOptionClick("ဘော်ဒီ")}
                            >
                                <div className="flex items-center">
                                    <div className={`w-2 h-2 rounded-full mr-3 ${filter === "ဘော်ဒီ" ? "bg-white" : "bg-crimson"}`}></div>
                                    {t("body")}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Enhanced Content Area */}
            <div className="relative z-10 flex-1 px-1 py-4 overflow-auto">
                {selectedMatches.length > 0 ? (
                    <div className="space-y-4">
                        {sortedMatches?.map((data, index) => {
                            if (data?.gamblingTypeId === 2) {
                                return (
                                    <Link
                                        key={data?.gamblingId || index}
                                        to={`/selected-matches-detail/${data?.gamblingId}`}
                                        onClick={() => {
                                            dispatch(setSelectedMatchesDetail(data));
                                            handleSongClick();
                                        }}
                                        className="block hover:scale-[1.02] transition-transform duration-300"
                                    >
                                        <SelectedMatchesCard match={data} />
                                    </Link>
                                );
                            } else {
                                return (
                                    <div key={data?.gamblingId || index} className="hover:scale-[1.02] transition-transform duration-300">
                                        <SelectedMatchesCard match={data} />
                                    </div>
                                );
                            }
                        })}
                    </div>
                ) : (
                    <div className="flex items-center justify-center flex-1 h-full">
                        <div className="p-8 text-center border-2 shadow-2xl bg-white/95 backdrop-blur-xl rounded-2xl border-crimson/30">
                            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 border-2 rounded-full bg-gradient-to-br from-crimson via-red-primary to-crimson border-golden/40">
                                <MdSportsSoccer size={32} className="text-white" />
                            </div>
                            <h3 className="mb-2 text-lg font-semibold text-blue-primary">No Matches Found</h3>
                            <p className="text-sm text-blue-primary">{t('noSelectedMatches')}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SelectedMatches;
